import React from 'react';
import { Button } from 'antd';
import { GlobalOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import ReactCountryFlag from 'react-country-flag';

const LanguageSwitcher: React.FC = () => {
  const { i18n } = useTranslation();

  const getFlag = (language: string) => {
    switch (language) {
      case 'en':
        return <ReactCountryFlag countryCode="GB" svg style={{ width: '24px', height: '16px', marginRight: '8px' }} />;
      case 'ru':
        return <ReactCountryFlag countryCode="RU" svg style={{ width: '24px', height: '16px', marginRight: '8px' }} />;
      default:
        return <GlobalOutlined />;
    }
  };

  const handleLanguageChange = () => {
    const newLanguage = i18n.language === 'en' ? 'ru' : 'en';
    i18n.changeLanguage(newLanguage);
    localStorage.setItem('language', newLanguage);
  };

  return (
    <Button
      type="text"
      icon={<GlobalOutlined />}
      onClick={handleLanguageChange}
      style={{ 
        marginRight: 16,
        display: 'flex',
        alignItems: 'center',
        gap: '8px'
      }}
    >
      {getFlag(i18n.language)}
      {i18n.language.toUpperCase()}
    </Button>
  );
};

export default LanguageSwitcher; 